import { useContext } from "react";
import { AppContext } from "src/providers/app-provider";

export const useApp = () => useContext(AppContext);
